module.exports = "<!-- <pos-chart></pos-chart> -->\n<pos-movements></pos-movements>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/dashboard/pos/pos.html
 ** module id = 416
 ** module chunks = 0
 **/